import React from "react";

export type CrossIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 10,
    height: 10,
  },
  medium: {
    width: 14,
    height: 14,
  },
  large: {
    width: 36,
    height: 36,
  },
};

export const CrossIcon: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  CrossIconProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#E01B3F" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 5.5H10.5V0.5H5.5V5.5H0.5V10.5H5.5V15.5H10.5V10.5H15.5V5.5Z"
        fill={color}
      />
    </svg>
  );
});

CrossIcon.displayName = "CrossIcon";
